import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import FormField from "../VendorOnboarding/FormField";
import { User } from "../../../service";

const Step2 = () => {
  const { values, setFieldValue } = useFormikContext();
  const [isLoading, setIsLoading] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [error, setError] = useState(null);
  // Controls whether inputs are editable. Locked by default; click Edit to modify.
  const [fieldsLocked, setFieldsLocked] = useState(true);

  // Fetch user data and auto-fill fields
  useEffect(() => {
    const fetchUserData = async () => {
      // Only fetch if data hasn't been fetched yet and fields are empty
      if (!isDataFetched && (!values.name || !values.email)) {
        setIsLoading(true);
        try {
          const userData = await User.getMe();
          console.log("User data fetched:", userData);

          // Auto-fill the fields with user data
          if (userData.data) {
            const { fullName, email, id, accountType } = userData.data;

            // Set created_by
            if (id) {
              setFieldValue("created_by", id);
            }

            // Set account_type
            if (accountType) {
              setFieldValue("account_type", accountType);
            }

            // Set tenant/owner name
            if (fullName) {
              setFieldValue("name", fullName);
            }

            // Set email
            if (email) {
              setFieldValue("email", email);
            }
          }

          setIsDataFetched(true);
          setFieldsLocked(true); // keep fields locked after auto-fill; user must click Edit
        } catch (error) {
          console.error("Error fetching user data:", error);
          setError(
            "Failed to load your information. Please fill in the details manually."
          );
          setFieldsLocked(false); // allow editing on error
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchUserData();
  }, [setFieldValue, isDataFetched, values.name, values.email]);

  // Retry function for manual retry
  const retryFetchData = async () => {
    setError(null);
    setIsDataFetched(false);
    setIsLoading(true);

    try {
      const userData = await User.getMe();
      console.log("User data fetched on retry:", userData);

      if (userData.data) {
        const { fullName, email, id, accountType } = userData.data;

        // Set created_by
        if (id) {
          setFieldValue("created_by", id);
        }

        // Set account_type
        if (accountType) {
          setFieldValue("account_type", accountType);
        }

        if (fullName) {
          setFieldValue("name", fullName);
        }

        if (email) {
          setFieldValue("email", email);
        }
      }

      setIsDataFetched(true);
      setFieldsLocked(true);
    } catch (error) {
      console.error("Error fetching user data on retry:", error);
      setError(
        "Failed to load your information. Please fill in the details manually."
      );
      setFieldsLocked(false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className=" flex justify-center items-cente w-full  ">
      <div className="w-full rounded-[16px]  flex flex-col md:gap-4 gap-3 items-center  ">
        <div className="w-full">
          {/* Status + Edit toggle */}
          <div className="flex items-center mb-2 justify-between">
            <h5 className="text-sm text-[#333333] flex items-center gap-2">
              {isLoading
                ? "Loading your information..."
                : isDataFetched
                ? "Auto-filled from your records"
                : error
                ? "Failed to auto-fill"
                : "Will auto-fill from your records"}
              {error && (
                <button
                  onClick={retryFetchData}
                  className="text-xs text-blue-600 hover:text-blue-800 underline"
                  disabled={isLoading}
                >
                  Retry
                </button>
              )}
            </h5>
            <button
              type="button"
              onClick={() => setFieldsLocked((prev) => !prev)}
              disabled={isLoading}
              className="px-3 py-1 text-sm rounded-md border border-gray-300 bg-white hover:bg-gray-50 disabled:opacity-50"
            >
              {fieldsLocked ? "Edit" : "Done"}
            </button>
          </div>

          <div className="space-y-3 w-full">
            <div>
              <FormField
                label="Tenant / Owner Name:"
                name="name"
                type="text"
                placeholder="Enter Name"
                disabled={fieldsLocked}
              />
            </div>
            {/* Email only (phone removed as requested) */}
            <div>
              <FormField
                label="Email Address:"
                name="email"
                type="email"
                placeholder="Enter Email Address"
                disabled={fieldsLocked}
              />
            </div>
          </div>
          {error && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}
          {/* Removed the "Yes, this is correct" confirmation checkbox */}
        </div>
      </div>
    </div>
  );
};

export default Step2;
